<template>
  <Panel :variant="['transparent']" class="battle-card-panel custom-scrollbar">
    <!-- <ListItemAccount
      v-bind="{
        type: player.type,
        avatar: player.avatar || player.logo,
        name: $filters.displayName(player),
        accountId: player._id,
        approved: player.isAmbassador || player.validated,
        size: 30,
      }"
    /> -->
    <div
      class="d-flex align-items-center w-100"
      :class="[`justify-content-${royale ? 'center' : 'between'}`]"
    >
      <PlayerCard
        v-if="!royale"
        :player="player"
        :description="scoreDescriptionText(myAccountNumber)"
        class="player-one align-items-start"
      />
      <component
        :is="getScoresComponent()"
        v-model="results"
        class="scores-block mb-1 col-6 text-center secondary-font results-score-sm"
        :class="{ 'flex-row-reverse': !royale && !!myAccountNumber }"
        :edit-mode="false"
        :default-values="['?', '?']"
        separator="-"
        :royale="royale"
        @update="setScores($event, 1)"
      />
      <PlayerCard
        v-if="!royale"
        :player="secondPlayer"
        :description="scoreDescriptionText(myAccountNumber ? 0 : 1)"
        class="player-two align-items-end"
      />
    </div>
    <component
      :is="getScoresComponent()"
      v-model="results"
      class=" mb-1 col-12 mx-auto text-center secondary-font scores-smaller-results"
      :class="{ 'flex-row-reverse': !royale && !!myAccountNumber }"
      :edit-mode="false"
      :default-values="['?', '?']"
      separator="-"
      :royale="royale"
      @update="setScores($event, 1)"
    />
    <MediaRow v-if="attachments.length" :media="attachments" class="my-2" />
    <!-- <TextSection v-if="uri" class="mx-2" :title="$$t('Uri')" :description="uri">
      <template #description>
        <a :href="uri" class="text-truncate" target="_blank">{{ uri }}</a>
      </template>
    </TextSection> -->
    <!-- <TextSection v-if="comment" class="mx-2" :description="comment" /> -->
    <TextBlock
      v-if="comment"
      :text="comment"
      variant="secondary"
      class="d-flex mt-5"
    />
  </Panel>
</template>

<script>
import Panel from '@/components/atoms/Panel';
// import ListItemAccount from '@/components/common/ListItemAccount';
import Scores from '@/components/tournaments/Scores.vue';
import RoyaleScores from '@/components/tournaments/RoyaleScores.vue';
// import SecondaryText from '@/components/atoms/SecondaryText';
// import TextSection from '@/components/text/TextSection';
import { translate } from '@/mixins/translate';
import MediaRow from '@/components/common/MediaRow.vue';
import TextBlock from '@/components/atoms/TextBlock';
import PlayerCard from './PlayerCard.vue';

export default {
  name: 'BattleCard',
  components: {
    Panel,
    // ListItemAccount,
    Scores,
    RoyaleScores,
    // SecondaryText,
    // TextSection,
    MediaRow,
    TextBlock,
    PlayerCard,
  },
  mixins: [translate('_web_battle-results-tab-card')],
  props: {
    battle: {
      type: Object,
      required: true,
    },
    player: {
      type: Object,
      default: () => {},
    },
    secondPlayer: {
      type: Object,
      default: () => {},
    },
    results: {
      type: Object,
      default: () => {},
    },
    royale: {
      type: Boolean,
      default: false,
    },
    myAccountNumber: {
      type: Number,
      default: -1,
    },
  },
  computed: {
    attachments() {
      return this.results.attachments;
    },
    comment() {
      return this.results.text;
    },
    uri() {
      return this.results.uri;
    },
  },
  methods: {
    scoreDescriptionText(val) {
      return this.myAccountNumber && this.myAccountNumber === val
        ? this.$$t('You', 'you-label')
        : this.$$t('Opponent', 'opponent-label');
    },
    getScoresComponent() {
      return this.royale ? RoyaleScores : Scores;
    },
  },
};
</script>
<style lang="scss">
.scores-block {
  border: none;
  font-size: 4rem;
  line-height: 4rem;
  max-width: 200px;
  &.scores .scores_item {
    height: 80px;
    width: 100%;
    background: var(--ph-card);
    border-radius: 8px;
    font-size: 40px;
    line-height: 75px;
  }
}
.scores-smaller-results {
  display: none !important;

  border: none;
  font-size: 4rem;
  line-height: 4rem;
  max-width: 200px;
  min-width: 200px;
  &.scores .scores_item {
    height: 80px;
    width: 100%;
    background: var(--ph-card);
    border-radius: 8px;
    font-size: 40px;
    line-height: 75px;
  }
}
@media (max-width: 767px) {
  .results-score-sm {
    display: none !important;
  }
  .scores-smaller-results {
    display: flex !important;
    flex-direction: row;

    justify-self: center !important;
  }
}
</style>
